import { render, staticRenderFns } from "./comboTemplate.vue?vue&type=template&id=15809720&scoped=true"
import script from "./comboTemplate.vue?vue&type=script&lang=js"
export * from "./comboTemplate.vue?vue&type=script&lang=js"
import style0 from "./comboTemplate.vue?vue&type=style&index=0&id=15809720&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15809720",
  null
  
)

export default component.exports